webpackJsonp([4,21],{

/***/ 109:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_popup__ = __webpack_require__(163);



/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_popup__["a" /* default */]],
    props: {
        democreditLogin: Boolean,
        lang: null,
        emptytoken: null,
        invalidtoken: null
    },
    data: function data() {
        return {
            token_demo: this.token_demo,
            error: {
                tokenReq: false,
                tokenmessage: ''
            }
        };
    },
    mounted: function mounted() {
        this.popupBreath();
    }
});

/***/ }),

/***/ 12:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_authCommon__ = __webpack_require__(13);



/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_authCommon__["a" /* default */]],
    data: function data() {
        return {
            full: false
        };
    },

    methods: {},
    mounted: function mounted() {
        var _this = this;

        if (this.popupFestival) {
            this.popupBreath();

            var img = new Image();
            img.onload = function () {
                if (window.innerHeight < img.height || window.innerWidth < img.width) {
                    _this.full = true;
                } else {
                    _this.full = false;
                }
            };

            img.src = this.popupFestival.festival_popup.img;
        }
    }
});

/***/ }),

/***/ 13:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      popupFestival: window._popupFestival,
      inputLength: window._inputLength
    };
  },

  methods: {
    popupBreath: function popupBreath() {
      var VUE = this;
      if (this.popupFestival.festival_popup.flag == true) {
        $('.fadein').fadeIn();
        setTimeout(function () {
          VUE.closePopup();
        }, 5000);
      }
    },
    closePopup: function closePopup() {
      $('.fadein').fadeOut();
    }
  }
});

/***/ }),

/***/ 162:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_popup_vue__ = __webpack_require__(109);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e69cfc4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_popup_vue__ = __webpack_require__(164);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_popup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e69cfc4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_popup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 163:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_events_event_bus__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["a"] = ({

  methods: {
    popupBreath: function popupBreath() {
      var VUE = this;
      if (this.democreditLogin == true) {
        $('.fadeinDemo').fadeIn();
      }
    },
    closePopup: function closePopup() {
      __WEBPACK_IMPORTED_MODULE_0__vue_events_event_bus__["a" /* default */].$emit('setDemoFlag', false);
      $('.fadeinDemo').fadeOut();
    },
    login: function login() {
      var _this = this;

      if (this.token_demo == '' || typeof this.token_demo == 'undefined') {
        this.error.tokenReq = true;
        this.error.tokenmessage = this.lang.emptytoken;
      } else {
        var re = /^[a-z\d\-_\s]+$/i;
        var re1 = re.test(this.token_demo);

        if (re1) {
          var url = _baseUrl + '/login';
          this.$ajax({
            method: 'post',
            url: url,
            data: {
              token: this.token_demo,
              action: 'logincreditdemo'
            }
          }).done(function (response) {
            console.log("done");
          }).catch(function (error) {
            _this.error.tokenReq = true;
            _this.error.tokenmessage = error.responseJSON.message;
          });
        } else {
          this.error.tokenReq = true;
          this.error.tokenmessage = this.lang.invalidtoken;
        }
      }
    }
  }
});

/***/ }),

/***/ 164:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"democreditloginPopup"},[_c('div',{staticClass:"fadeinDemo"},[_c('div',{staticClass:"popup-box"},[_c('div',{staticClass:"message"},[_c('div',{staticClass:"demo_caption"},[_c('span',[_vm._v(_vm._s(_vm.lang.entertoken))])]),_vm._v(" "),_c('div',{staticClass:"demo_token"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.token_demo),expression:"token_demo"}],attrs:{"type":"text","id":"tokendemo","maxlength":"8"},domProps:{"value":(_vm.token_demo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.token_demo=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"div_error",attrs:{"id":"div_error","name":"div_error"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.error.tokenReq),expression:"error.tokenReq"}],staticClass:"error_msg",attrs:{"id":"error_msg"}},[_vm._v("\n                        "+_vm._s(_vm.error.tokenmessage)+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"btn_submit"},[_c('button',{staticClass:"btn btn_sb",attrs:{"type":"submit","tabindex":"3"},on:{"click":function($event){$event.preventDefault();return _vm.login.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.lang.submit))]),_vm._v(" "),_c('button',{staticClass:"btn btn_cc",attrs:{"type":"submit","tabindex":"3"},on:{"click":function($event){$event.preventDefault();return _vm.closePopup.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.lang.cancel))])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 18:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_popup_festival_vue__ = __webpack_require__(12);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_82797d42_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_popup_festival_vue__ = __webpack_require__(19);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_popup_festival_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_82797d42_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_popup_festival_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 19:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.popupFestival)?_c('div',[_c('div',{staticClass:"fadein"},[_c('div',{staticClass:"popup-image",class:(_vm.full) ? 'full' : ''},[_c('div',{staticClass:"guide-close-button floating-right"},[_c('i',{staticClass:"fa fa-times-circle fa-2x",on:{"click":_vm.closePopup}})]),_vm._v(" "),_c('div',{staticClass:"message"}),_vm._v(" "),_c('img',{staticStyle:{"cursor":"pointer","height":"100%"},attrs:{"src":_vm.popupFestival.festival_popup.img,"id":"fadein1-img"}})])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 237:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_core_core__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_popup_vue__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vue_components_loadingScreen__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_cookie__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_popup_festival__ = __webpack_require__(18);










/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    popup: __WEBPACK_IMPORTED_MODULE_2__components_popup_vue__["a" /* default */],
    loadingScreen: __WEBPACK_IMPORTED_MODULE_4__vue_components_loadingScreen__["a" /* default */],
    popupFestival: __WEBPACK_IMPORTED_MODULE_6__components_popup_festival__["a" /* default */]
  },
  data: function data() {
    return {
      isRememberMe: false,
      loading: false,
      langSelect: lang_select,
      cookielang: _cookie,
      lang: lang,
      langList: langList,
      formData: {
        accname: '',
        pass: ''
      },
      error: {
        loginIdReq: false,
        message: ''
      },
      currentTemplate: window._currentTemplate,
      customTemplate: window._customTemplate,
      companycode: window.compcode,
      inputLength: window._inputLength,
      showDemo: window.showDemo,
      showLogo: window.showLogo,
      popupFlag: false,
      emptytoken: window.emptytoken,
      showCreditDemoFlag: window.showCreditDemoFlag,
      UID: JSON.parse(__WEBPACK_IMPORTED_MODULE_5_vue_cookie___default.a.get('UID')),
      isAPI: isAPI,
      isP: true,
      token: window.token,
      centerLogin: window.centerLogin,
      tableData: tableData
    };
  },

  computed: {},
  methods: {
    desktop: function desktop() {
      var redirect = window._baseUrl.replace(window._mobileTemplate, window._webTemplate) + '/login?desktop=1';
      window.location.href = redirect;
    },
    demoLogin: function demoLogin() {
      this.$ajax({
        method: 'post',
        url: window.demoLogin,
        data: {}
      }).done(function (res) {}.bind(this)).catch(function (errRes) {
        console.log(errRes);
      });
    },
    login: function login() {
      var _this = this;

      if (this.formData.accname == '') {
        this.error.loginIdReq = true;
        this.error.message = this.lang.emptyLoginId;
        $('#usr_lab').addClass('error').removeClass('on');
        $('#pwd_lab').removeClass('on');
      } else if (this.formData.pass == '') {
        this.error.loginIdReq = true;
        this.error.message = this.lang.emptyPassword;
        $('#usr_lab').removeClass('error').removeClass('on');
        $('#pwd_lab').addClass('error').removeClass('on');
      } else {
        if (this.isRememberMe) {
          this.$cookie.set(window.compcode + '_remember', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
            accname: this.formData.accname,
            isRememberMe: this.isRememberMe
          }));
        }
        this.error.loginIdReq = false;
        this.loading = true;
        this.formData.token = token.arr_9 + '|' + this.formData.accname;
        this.$ajax({
          method: 'post',
          url: '',
          data: this.formData
        }).catch(function (error) {
          _this.loading = false;
          _this.error.loginIdReq = true;
          _this.error.message = error.responseJSON.message;
        });
      }
    },
    handleEnterKey: function handleEnterKey(event) {
      if (event.keyCode === 13) {
        this.login();
      }
    },

    changeLanguage: function changeLanguage(value) {
      this.loading = true;
      this.$ajax({
        url: '',
        type: 'get',
        data: {
          language: value,
          token: token.arr_3
        }
      }).then(function (response) {
        window.location.reload();
      });
    },
    langClass: function langClass(lang) {
      if (lang == this.cookielang) {
        return 'btn_language on';
      }
      return 'btn_language';
    },
    demo: function demo() {
      this.popupFlag = true;
    },
    pcLogin: function pcLogin() {
      if (!__WEBPACK_IMPORTED_MODULE_5_vue_cookie___default.a.get('UID')) {
        this.error.loginIdReq = true;
        this.error.message = this.langList.login['LOGIN.ERR_MSG_PASSCODE_REMOVED'];
        this.isP = true;
        return;
      }
      var arr = {};
      arr['usrn'] = JSON.parse(__WEBPACK_IMPORTED_MODULE_5_vue_cookie___default.a.get('UID')).usrn;

      arr['nsid'] = JSON.parse(__WEBPACK_IMPORTED_MODULE_5_vue_cookie___default.a.get('UID')).nsid;
      arr['page'] = '1';
      __WEBPACK_IMPORTED_MODULE_5_vue_cookie___default.a.set('UID', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(arr));
      window.location.href = 'login';
    },

    input_Green: function input_Green(value) {
      if (value == 1) {
        $('#usr_lab').addClass('on');
        $('#pwd_lab').removeClass("on");
      } else if (value == 2) {
        $('#pwd_lab').addClass('on');
        $('#usr_lab').removeClass("on");
      } else {
        $('#usr_lab').removeClass("on");
        $('#pwd_lab').removeClass("on");
      }
    },
    input_Clear: function input_Clear(value) {
      if (value == 1) {
        $('#usr').val('');
      } else if (value == 2) {
        $('#pwd').val('');
      }
    },
    defaultLogo: function defaultLogo() {
      if (this.customTemplate && !this.customTemplate['logo_mhg']) {
        return 'index_top_pic';
      }
    },
    centerLoginLink: function centerLoginLink() {
      return this.centerLogin.domain + this.centerLogin.path;
    },
    getCenterLoginDomain: function getCenterLoginDomain() {
      var url = new URL(this.centerLogin.domain);
      var domain = url.hostname;
      return domain;
    },
    browserMinReqText: function browserMinReqText() {
      var minReqText = '<a id="sysReq">' + this.lang.browserMinReq + '</a>';
      var replacedText = this.lang.browserMinReqMsg.replace('{minReq}', minReqText);
      return replacedText;
    },

    sysReqClick: function sysReqClick() {
      $('#body_show').hide();
      $('#sysreq_show').show();
      $('.content_sys').css('padding-top', '80px');

      var title_sys = $('<span>').text(this.lang.minimum);
      $('.title_sys').children().filter(':not(#go_back, img)').remove();
      $('.title_sys').append(title_sys);
      var box_sys = $('<div>').addClass('box_sys');
      var description1 = $('<span>').addClass('text_sys').text(this.lang.sysMinDesc1);
      var description2 = $('<span>').addClass('subtitle_sys').text(this.lang.sysMinDesc2);
      var description3 = $('<p>').text(this.lang.sysMinDesc3);
      var back_button = $('<div>').attr({
        'id': 'go_back_bottom',
        'class': 'btn_sys'
      }).text(this.lang.sysMinDesc4);

      box_sys.append(description1);
      $.each(this.tableData['TABLE'], function (key1, value1) {
        var subtitle = $('<span>').addClass('subtitle_sys').text(key1);
        box_sys.append(subtitle);
        $.each(value1, function (key2, value2) {
          var table = $('<table>').addClass('table_sys');
          var tbody = $('<tbody>');
          var tr_th = $('<tr>').addClass('table_sys_title');
          $.each(value2.th, function (key3, value3) {
            var th = $('<th>').text(value3);
            tr_th.append(th);
          });
          tbody.append(tr_th);
          $.each(value2.td, function (key4, value4) {
            var tr_td = $('<tr>');
            $.each(value4, function (key5, value5) {
              var td = $('<td>').html(value5);
              tr_td.append(td);
            });
            tbody.append(tr_td);
          });
          table.append(tbody);
          box_sys.append(table);
        });
      });
      box_sys.append(description2, description3, back_button);
      $('.content_sys').empty().append(box_sys);

      $('#go_back_bottom, #go_back').click(function (e) {
        e.preventDefault();
        $('#body_show').show();
        $('#sysreq_show').hide();
      });

      $('.chr_link').click(function (e) {
        window.open('https://www.google.com/chrome/', '_blank');
      });
      $('.saf_link').click(function (e) {
        window.open('https://support.apple.com/downloads/safari', '_blank');
      });
      $('.qq_link').click(function (e) {
        window.open('https://browser.qq.com/', '_blank');
      });
      $('.fox_link').click(function (e) {
        window.open('https://www.mozilla.org/', '_blank');
      });
    },

    setupClickEvent: function setupClickEvent() {
      var sysReqElement = document.getElementById('sysReq');
      var self = this;
      if (sysReqElement) {
        sysReqElement.addEventListener('click', function () {
          self.sysReqClick();
        });
      };
    },
    browserClick: function browserClick(value) {
      var browser_links = {
        1: 'https://www.google.com/chrome/',
        2: 'https://support.apple.com/downloads/safari',
        3: 'https://www.mozilla.org/'
      };
      window.open(browser_links[value], '_blank');
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    document.addEventListener("keydown", this.handleEnterKey);
    this.loading = false;
    $('#username').focus();
    if (__WEBPACK_IMPORTED_MODULE_5_vue_cookie___default.a.get('UID')) {
      var cookieUID = JSON.parse(__WEBPACK_IMPORTED_MODULE_5_vue_cookie___default.a.get('UID'));
      if (cookieUID.usrn != -1) {
        var arr = {};

        arr['usrn'] = cookieUID.usrn;
        arr['nsid'] = cookieUID.nsid;
        arr['page'] = '1';
        __WEBPACK_IMPORTED_MODULE_5_vue_cookie___default.a.set('UID', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(arr));
      }
    }
    __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$on('setDemoFlag', function (res) {
      _this2.popupFlag = res;
    });

    if (this.centerLogin) {
      var scrollStyle1 = document.createElement('style');
      scrollStyle1.innerHTML = '\n        ::-webkit-scrollbar {\n          width: 4px;\n        }\n      ';
      var scrollStyle2 = document.createElement('style');
      scrollStyle2.innerHTML = '\n        ::-webkit-scrollbar-thumb {\n          background: #ccc;\n        }\n      ';
      $('head').append(scrollStyle1, scrollStyle2);
      $('.login_main').css({
        'background': '#f5f5f5',
        'height': 'auto'
      });
      $('.box_login').css({
        'margin': '16px auto',
        'box-shadow': '0 0 0 0 transparent',
        'padding': '24px 16px 16px 16px'
      });
      $('.box_browser').css({
        'box-shadow': '0 0 0 0 transparent'
      });
    }
    document.addEventListener('DOMContentLoaded', this.setupClickEvent);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener("keydown", this.handleEnterKey);
  },
  beforeMount: function beforeMount() {
    localStorage.removeItem('bts');
    var cookieRemember = this.$cookie.get(window.compcode + '_remember');
    if (cookieRemember) {
      cookieRemember = JSON.parse(cookieRemember);
      this.isRememberMe = cookieRemember.isRememberMe;
      if (cookieRemember.isRememberMe) {
        this.formData.accname = cookieRemember.accname;
      }
    }
    if (__WEBPACK_IMPORTED_MODULE_5_vue_cookie___default.a.get('UID') && JSON.parse(__WEBPACK_IMPORTED_MODULE_5_vue_cookie___default.a.get('UID')).usrn) {
      var usrn = JSON.parse(__WEBPACK_IMPORTED_MODULE_5_vue_cookie___default.a.get('UID')).usrn;
      if (usrn == '-1' || !JSON.parse(__WEBPACK_IMPORTED_MODULE_5_vue_cookie___default.a.get('UID')).nsid) {
        this.isP = true;
      } else {
        this.isP = false;
      }
    }
    if (__WEBPACK_IMPORTED_MODULE_5_vue_cookie___default.a.get('PC_RMV')) {
      this.error.loginIdReq = true;
      this.error.message = __WEBPACK_IMPORTED_MODULE_5_vue_cookie___default.a.get('PC_RMV');
      __WEBPACK_IMPORTED_MODULE_5_vue_cookie___default.a.delete('PC_RMV');
    }
  }
});

/***/ }),

/***/ 32:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        loading: false
    },
    data: function data() {
        return {};
    },
    mounted: function mounted() {}
});

/***/ }),

/***/ 33:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_events_event_bus__ = __webpack_require__(4);




window.loading = false;

$.ajaxSetup({
  beforeSend: function beforeSend(xhr, settings) {
    var index = '';
    var token_val = '';
    var enableLoading = true;
    if (settings.data) {
      var data = settings.data.split('&');
      var data = data.indexOf("enableLoading=false");
      enableLoading = data >= 0 ? false : true;
      settings.data = settings.data.replace("&enableLoading=false", "");
      settings.data = settings.data.replace("&enableLoading=true", "");
      var url = settings.data;
    } else if (settings.type == 'GET') {
      var data = settings.url.indexOf("enableLoading=false");
      enableLoading = data >= 0 ? false : true;
      settings.url = settings.url.replace("&enableLoading=false", "");
      settings.url = settings.url.replace("&enableLoading=true", "");
      var url = settings.url;
    }

    if (url) {
      var valid = url.indexOf("&");
      if (valid >= 0) {
        var suburl = url.split('&');
        var delimiter = '&';
      } else {
        var suburl = url.split('?');
        var delimiter = '?';
      }

      suburl.forEach(function (value, i) {
        if (value.substring(0, 6) == 'token=') {
          index = i;
          token_val = value.split('=');
          if (settings.data) {
            settings.data = url.replace(delimiter + suburl[index], "");
          } else if (settings.type == 'GET') {
            settings.url = url.replace(delimiter + suburl[index], "");
          }
          xhr.setRequestHeader('TOKEN', decodeURIComponent(token_val[1]));
        }
      });
    }

    __WEBPACK_IMPORTED_MODULE_1__vue_events_event_bus__["a" /* default */].$emit('enableLoading', enableLoading);
    if ($.inArray(settings.type, ['POST', 'PUT', 'DELETE', 'PATCH']) > -1) {
      if (!_.isUndefined(settings.data)) {
        var csrf = {
          'csrf_name': function () {
            return $('meta[name="csrf_name"]').attr('content');
          }(),
          'csrf_value': function () {
            return $('meta[name="csrf_value"]').attr('content');
          }()
        };
      }
      return true;
    }
  }
});

$(document).ajaxSuccess(function (event, xhr, options) {
  __WEBPACK_IMPORTED_MODULE_1__vue_events_event_bus__["a" /* default */].$emit('enableLoading', false);

  if (!_.isUndefined(xhr.responseJSON)) {
    if (xhr.responseJSON.redirect) {
      window.location.href = xhr.responseJSON.redirect;
    }
  }
});

$(document).ajaxComplete(function (event, xhr, options) {
  if (window.navigator.userAgent.indexOf('Safari') >= 0 && window.navigator.userAgent.indexOf('Chrome') == -1) {
    $('.gridContainer').height('90vh');
    $('.gridContainer').css('overflow-y', 'auto');
  }
  if (xhr.getResponseHeader('X-Auth') == '0') {
    window.location = 'login';
  }

  if (xhr.status === 0) {
    location.reload();
  }

  if (xhr.getResponseHeader('X-Csrf-Name') && xhr.getResponseHeader('X-Csrf-Value')) {
    var csrf = {
      'csrf_name': xhr.getResponseHeader('X-Csrf-Name'),
      'csrf_value': xhr.getResponseHeader('X-Csrf-Value')
    };

    $.each(csrf, function (k, v) {
      $('meta[name="' + k + '"]').attr('content', v);
    });
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$ajax = $.ajax;

/***/ }),

/***/ 34:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function injectStyle (ssrContext) {
  __webpack_require__(35)
}
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 35:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 4:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);




var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = (EventBus);

/***/ }),

/***/ 402:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_apps_auth_login_vue__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);




new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#login',
  template: '<Login ></Login>',
  components: { Login: __WEBPACK_IMPORTED_MODULE_0__vue_apps_auth_login_vue__["a" /* default */] }
});

/***/ }),

/***/ 403:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__ = __webpack_require__(237);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02e4f1c4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__ = __webpack_require__(406);
function injectStyle (ssrContext) {
  __webpack_require__(404)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02e4f1c4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 404:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 406:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isAPI && !_vm.showDemo)?_c('div',{staticClass:"login"},[_c('div',{attrs:{"id":"body_show"}},[_c('div',{staticClass:"gridContainer clearfix LoginEN"},[_c('div',{staticClass:"login_main"},[_c('div',{staticClass:"LayoutDiv tablet",attrs:{"id":"div_langx","name":"div_langx"}},[_c('div',{staticStyle:{"margin-left":"auto","margin-right":"auto","height":"75px"}},[(_vm.customTemplate && _vm.showLogo)?_c('img',{staticStyle:{"margin-top":"-20","width":"90px"},attrs:{"src":_vm.customTemplate['logo_home']}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"tablet_main"},[_c('div',{staticClass:"err_info",attrs:{"id":"err_info"}},[_c('br'),_vm._v(" "),_c('center',[_c('font',{attrs:{"id":"hr_info"}},[_vm._v(_vm._s(_vm.lang.sessionExipred))])],1)],1)])])])]),_vm._v(" "),_vm._m(0)]):_c('div',{staticClass:"login",attrs:{"lang":_vm.cookielang}},[_c('loadingScreen',{attrs:{"loading":_vm.loading}}),_vm._v(" "),_c('popupFestival'),_vm._v(" "),(_vm.popupFlag)?_c('popup',{attrs:{"democreditLogin":_vm.popupFlag,"lang":_vm.lang}}):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"notice_show"}}),_vm._v(" "),_c('div',{staticStyle:{"height":"100vh"},attrs:{"id":"body_show"}},[_c('div',{staticClass:"login_main"},[_c('div',{staticClass:"box_language"},[_c('span',{class:_vm.langClass(_vm.langSelect[2].language_code),attrs:{"id":"langx_zh-cn","name":"langx_zh-cn"},on:{"click":function($event){return _vm.changeLanguage(2)}}},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.langSelect[2].caption)+"版\n\t\t\t\t\t")]),_vm._v(" "),_c('span',{class:_vm.langClass(_vm.langSelect[3].language_code),attrs:{"id":"langx_zh-tw","name":"langx_zh-tw"},on:{"click":function($event){return _vm.changeLanguage(3)}}},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.langSelect[3].caption)+"版\n\t\t\t\t\t")]),_vm._v(" "),_c('span',{class:_vm.langClass(_vm.langSelect[1].language_code),attrs:{"id":"langx_en-us","name":"langx_en-us"},on:{"click":function($event){return _vm.changeLanguage(1)}}},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.langSelect[1].caption)+"\n\t\t\t\t\t")])]),_vm._v(" "),(!_vm.centerLogin)?[_c('i',{staticClass:"comp-logo",class:_vm.defaultLogo()},[(_vm.customTemplate)?_c('img',{attrs:{"src":_vm.customTemplate['logo_mhg']}}):_vm._e()])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"box_login"},[_c('label',{staticClass:"lab_input",attrs:{"id":"usr_lab"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.accname),expression:"formData.accname"}],staticClass:"userid",class:_vm.cookielang,attrs:{"id":"usr","type":"text","autocomplete":"off","required":"required"},domProps:{"value":(_vm.formData.accname)},on:{"click":function($event){return _vm.input_Green(1)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "accname", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"text_input",attrs:{"data-tooltip":_vm.lang.username_def}}),_vm._v(" "),_c('i',{staticClass:"btn_clear",attrs:{"id":"usr_dele","data-system":"ios12"},on:{"click":function($event){return _vm.input_Clear(1)}}},[_c('img',{attrs:{"src":"assets/images/icon_close_b.svg"}})])]),_vm._v(" "),_c('label',{staticClass:"lab_input",attrs:{"id":"pwd_lab"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.pass),expression:"formData.pass"}],staticClass:"pwd",class:_vm.cookielang,attrs:{"id":"pwd","type":"password","autocomplete":"off","required":"required"},domProps:{"value":(_vm.formData.pass)},on:{"click":function($event){return _vm.input_Green(2)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "pass", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"text_input",attrs:{"data-tooltip":_vm.lang.password_def}}),_vm._v(" "),_c('i',{staticClass:"btn_clear",attrs:{"id":"pwd_dele","data-system":"ios12"},on:{"click":function($event){return _vm.input_Clear(2)}}},[_c('img',{attrs:{"src":"assets/images/icon_close_b.svg"}})])]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.error.loginIdReq),expression:"error.loginIdReq"}],staticClass:"text_error",attrs:{"id":"text_error"}},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.error.message)+"\n\t\t\t\t\t")]),_vm._v(" "),_c('div',[_c('div',{staticClass:"btn_login",attrs:{"id":"login_btn"},on:{"click":function($event){$event.preventDefault();return _vm.login.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.lang.login))])]),_vm._v(" "),(_vm.showDemo && _vm.isAPI)?_c('div',[_c('div',{staticClass:"btn_login",attrs:{"id":"btn_login_demo"},on:{"click":function($event){$event.preventDefault();return _vm.demoLogin.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.lang.demo))])]):_vm._e(),_vm._v(" "),(_vm.showCreditDemoFlag && !_vm.isAPI)?_c('div',[_c('div',{staticClass:"btn_login",attrs:{"id":"btn_login_credit"},on:{"click":function($event){$event.preventDefault();return _vm.demo.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.lang.demo))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"box_remember"},[_c('label',{staticClass:"check_remember lab_radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isRememberMe),expression:"isRememberMe"}],attrs:{"id":"remember","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.isRememberMe)?_vm._i(_vm.isRememberMe,null)>-1:(_vm.isRememberMe)},on:{"change":function($event){var $$a=_vm.isRememberMe,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.isRememberMe=$$a.concat([$$v]))}else{$$i>-1&&(_vm.isRememberMe=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.isRememberMe=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"}),_vm._v(" "),_c('tt',[_vm._v(_vm._s(_vm.langList.login['LOGIN.LBL_REMEMBERME']))])],1)]),_vm._v(" "),(_vm.isAPI == 0 && !_vm.isP)?[_c('input',{staticClass:"btn_passcode",attrs:{"id":"btn_pwd4","type":"button","value":_vm.langList.login['LOGIN.MSG_LOGIN_USING_PASSCODE']},on:{"click":function($event){$event.preventDefault();return _vm.pcLogin($event)}}})]:_vm._e()],2),_vm._v(" "),(_vm.centerLogin)?[_c('div',{staticClass:"box_browser"},[_c('span',[_vm._v(_vm._s(_vm.lang.browserRecomm))]),_vm._v(" "),_c('div',{staticClass:"wrap_browser"},[_c('div',{staticClass:"btn_browser",attrs:{"id":"browse_CHR"}},[_c('i',{staticClass:"icon_CHR",on:{"click":function($event){return _vm.browserClick(1)}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.lang.browserChrome))])]),_vm._v(" "),_c('div',{staticClass:"btn_browser",attrs:{"id":"browse_SAF"}},[_c('i',{staticClass:"icon_SAF",on:{"click":function($event){return _vm.browserClick(2)}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.lang.browserSafari))])]),_vm._v(" "),_c('div',{staticClass:"btn_browser",attrs:{"id":"browse_FOX"}},[_c('i',{staticClass:"icon_FOX",on:{"click":function($event){return _vm.browserClick(3)}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.lang.browserFirefox))])])]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.browserMinReqText())}})])]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"push"})]),_vm._v(" "),_vm._m(1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sys",staticStyle:{"display":"none"},attrs:{"id":"sysreq_show"}},[_c('div',{staticClass:"title_sys"},[_c('div',{staticClass:"btn_back",attrs:{"id":"go_back"}},[_c('img',{attrs:{"id":"irightarr","src":"assets/images/icon_rightarr.svg"}})])]),_vm._v(" "),_c('div',{staticClass:"content_sys"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sys",staticStyle:{"display":"none"},attrs:{"id":"sysreq_show"}},[_c('div',{staticClass:"title_sys"},[_c('div',{staticClass:"btn_back",attrs:{"id":"go_back"}},[_c('img',{attrs:{"id":"irightarr","src":"assets/images/icon_rightarr.svg"}})])]),_vm._v(" "),_c('div',{staticClass:"content_sys"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 50:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loadingScreen_vue__ = __webpack_require__(32);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d6673ae_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loadingScreen_vue__ = __webpack_require__(59);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loadingScreen_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d6673ae_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loadingScreen_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 59:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"loading",attrs:{"id":"loading"}},[_c('i',{staticClass:"icon_load"})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 8:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ajax_http_interceptor__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_cookie__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_apps_core_core_vue__ = __webpack_require__(34);


__webpack_require__(46).polyfill();





__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_cookie___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].mixin({
	data: function data() {
		return {
			_: _
		};
	}
});


/* harmony default export */ __webpack_exports__["default"] = (new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
	components: { Core: __WEBPACK_IMPORTED_MODULE_3__vue_apps_core_core_vue__["a" /* default */] }
}));

/***/ })

},[402]);


// WEBPACK FOOTER //
// js/auth/login.5c2bd198a43e8d596bac.js